export default __webpack_public_path__ + "static/media/marc.5d8f9145.jpg";